<template>
<div class="col backgroundForm">
    <div class="col col-md-10 offset-md-1">
        <div class="col col-md-10 offset-md-1">
            <div class="col col-md-6 offset-md-3">
                <div class="alert alert-danger" role="alert">
                    <h4 class="alert-heading">Reporte de Lectura de Niveles de Rios</h4>        
                </div>
            </div>
        </div>

        <div class="form-row">
                        <div class="form-group col col-md-4 offset-md-2">
                            <label for="list_lake">Rio/lago</label>
                            <select name="lis_lake" id="list_lake" class="form-control" v-model="lake_select_aux" @change="mSelectRiver" v-html="option_river">
                                <!-- <option v-for="lr in list_river" :key="lr.id" :value="lr">{{ lr.name_lake }} - {{ lr.cuenca }}</option> -->
                            </select>
                        </div>
                        <div class="form-group col col-md-4" v-if="list_sector.length > 0">
                            <label for="list_lake">Sector</label>
                            <select name="lis_lake" id="list_lake" class="form-control" v-model="sector_select" @change="mSelectSector">
                                <option v-for="slr in list_sector" :key="slr.id_sector" :value="slr">{{ slr.sector }} </option>
                            </select>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col col-md-4 offset-md-2">
                            <label for="date_init_discharge" class="badge badge-info">DEL:</label>         
                            <datetime v-model="read_river.date_init" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                        </div>
                        <div class="form-group col col-md-4">
                            <label for="date_end_discharge" class="badge badge-info">AL:</label>         
                            <datetime v-model="read_river.date_end" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                        </div>
                    </div>

            <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link active" id="nav-rep-river" data-toggle="tab" href="#nav-xls-river" role="tab" aria-controls="nav-home" aria-selected="true">Reporte Excel</a>
                    <a class="nav-item nav-link" id="nav-grap-river" data-toggle="tab" href="#nav-graph-river" role="tab" aria-controls="nav-detail" aria-selected="false" >Graficos Niveles</a>
                </div>
            </nav>
            

            <div class="tab-content" id="nav-tabContent">
                 <div class="tab-pane fade show active" id="nav-xls-river" role="tabpanel" aria-labelledby="nav-home-tab">
                    <h6>REPORTE EXCEL</h6>
                    <hr>

                    
                    <button class="btn btn-outline-success col col-md-4 offset-md-2" @click="mReportExcelRio"><font-awesome-icon icon="file-excel" size="2x" /> Reporte Excel Rio/Lago</button>
                    <button class="btn btn-outline-info col col-md-4" @click="mReportExcelSector"><font-awesome-icon icon="file-excel" size="2x" /> Reporte Excel Sector</button>

                 </div>

                 <div class="tab-pane fade" id="nav-graph-river" role="tabpanel" aria-labelledby="nav-home-tab">
                    <h6>GRAFICOS LECTURA DE NIVELES</h6>
                    <hr>
                    <button class="btn btn-outline-info col col-md-4 offset-md-2" @click="mGraphicsRiver(2)"><font-awesome-icon icon="chart-line" size="2x" /> Reporte Grafico General</button>
                    <button class="btn btn-outline-warning col col-md-4" @click="mGraphicsRiver(1)"><font-awesome-icon icon="chart-line" size="2x" /> Reporte Grafico Sector</button>

                    <line-chart :title="optionGraphic.title" :subtitle="optionGraphic.subtitle" :categories="optionGraphic.categories" :series-auxiliares="optionGraphic.series"  v-if="renderComponent"></line-chart>

                 </div>
            </div>
    </div>
</div>       
        

</template>

<script>

import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

import lineChart from '../charts/LineChart';

import modalLoading from '../modal/modalLoading';

export default {
    name:'report-river',
    data(){
        return{
            option_river:null,
            lake_select_aux:0,
            read_river:{
                date_init:null,
                date_end:null,
            },
            list_river:[],
            list_sector:[],
            lake_select:{id:0},
            sector_select:{id_sector:0},
            renderComponent:false,
            optionGraphic:{
                title:null,
                subtitle:null,
                yaxistitle:null,
                categories:[],
                nameSector:null,
                datoslectura:[],
                series:[]
            }
        }
    },
    mounted(){
        this.mChargeInit()
    },
    methods:{
        forceRerender() {
            // Remove my-component from the DOM
            this.renderComponent = false;

            // If you like promises better you can
            // also use nextTick this way
            this.$nextTick().then(() => {
                // Add the component back in
                this.renderComponent = true;
            });
        },
        mValidateFormLake(){
            if(this.lake_select.id === 0){
                toastr.warning('Seleccione un Rio/Lago', 'Advertencia')
                return false;
            }

            let adi=this.read_river.date_init.split('T');
            this.read_river.date_init=adi[0];

            if( this.read_river.date_init === null || !(this.read_river.date_init.length === 10) ){
                toastr.error('La fecha de Inicio es incorrecta', 'Error');
                return false;
            }

            let ade=this.read_river.date_end.split('T');
            this.read_river.date_end=ade[0];

            if( this.read_river.date_end === null || !(this.read_river.date_end.length === 10) ){
                toastr.error('La fecha de Inicio es incorrecta', 'Error');
                return false;
            }

            return true
        },
        mReportExcelRio(){
            
            if(this.mValidateFormLake()){
                this.url_report=btoa('excelReadLake/'+this.lake_select.id+'/'+this.read_river.date_init+'/'+this.read_river.date_end+'/2');
                // let url_report=btoa(`${this.urlR}/${this.port_select.id }`);
                // let url_report=btoa(`pdfOrdopI/${id}`)
                let route = this.$router.resolve({path: `/report/${this.url_report}`});            
                window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            }else{
                toastr.info(`Seleccione una opcion`, 'Error');
            }
        },
        mValidateFormSector(){
            if(this.sector_select.id_sector === 0){
                toastr.warning('Seleccione un Sector', 'Advertencia')
                return false;
            }

            let adi=this.read_river.date_init.split('T');
            this.read_river.date_init=adi[0];

            if( this.read_river.date_init === null || !(this.read_river.date_init.length === 10) ){
                toastr.error('La fecha de Inicio es incorrecta', 'Error');
                return false;
            }

            let ade=this.read_river.date_end.split('T');
            this.read_river.date_end=ade[0];

            if( this.read_river.date_end === null || !(this.read_river.date_end.length === 10) ){
                toastr.error('La fecha de Inicio es incorrecta', 'Error');
                return false;
            }

            return true
        },
        async mGraphicsRiver(tys=1){
            // aqui llamamos a los datos del servidor para subirlos al grafico
            let idb=tys===1 ? this.sector_select.id_sector: this.lake_select.id;
            if(this.mValidateFormSector()){
                let listRiver=await axios.get(`getReadLake/${idb}/${this.read_river.date_init}/${this.read_river.date_end}/${tys}?api_token=${Vue.auth.getToken()}`);
                console.log(listRiver);
                if(listRiver.data.length > 0){
                    this.optionGraphic.title=listRiver.data[0].river_lake;
                    this.optionGraphic.subtitle=tys === 1 ? listRiver.data[0].sector_river_lake:'TODOS LOS SECTORES'; 
                    let auxData=listRiver.data;
                    this.optionGraphic.categories=[];
                    let serieAux=[];
                    // {
                    //     name: 'Rio Lago',
                    //     marker: {
                    //         symbol: "circle"
                    //     },
                    //     data: [-7.0, 6.9, 3 ]
                    // }

                    auxData.forEach(el => {
                        let inb=serieAux.findIndex(ibs=> ibs.name === el.sector_river_lake);
                        let read=0;
                        if(inb>-1){
                            // si es mayor a -1 solo añadimos la lectura del rio 
                            // tambien considerar las fechas en el array
                            if(el.type_read==='SNB'){
                                read=parseFloat(el.read_level);
                                serieAux[inb].data.push(read);
                            }else{
                                read=parseFloat(el.read_level)*-1;
                                serieAux[inb].data.push(read);
                            }
                        }else{
                            if(el.type_read==='SNB'){
                                read=parseFloat(el.read_level);
                            }else{
                                read=parseFloat(el.read_level)*-1;
                            }
                            let aux_temp={
                                name:el.sector_river_lake,
                                marker:{
                                    symbol:"circle"
                                },
                                data:[read]
                            }
                            serieAux.push(aux_temp);
                        }

                        // aqui verificamos las categorias es relacion a las fechas
                        let ibf=this.optionGraphic.categories.findIndex(elb=> elb===el.date_hour_read);
                        if(ibf===-1){
                            this.optionGraphic.categories.push(el.date_hour_read);
                        }                                                
                    });
                    // aqui vaciamos los datos que precisamos
                    this.optionGraphic.series=serieAux;
                    console.log(this.optionGraphic.series);

                    this.forceRerender();
                }else{
                    toastr.warning(`No hay datos registrados en Sistema`, 'Error');    
                }
                // console.log(listRiver);
                // this.list_river=listRiver.data;
                // console.log(this.url_report);
            }else{
                toastr.info(`Seleccione una opcion`, 'Error');
            } 
        },
        mReportExcelSector(){
            if(this.mValidateFormSector()){
                this.url_report=btoa('excelReadLake/'+this.sector_select.id_sector+'/'+this.read_river.date_init+'/'+this.read_river.date_end+'/1');
                console.log(this.url_report);
                // let url_report=btoa(`${this.urlR}/${this.port_select.id }`);
                // let url_report=btoa(`pdfOrdopI/${id}`)
                let route = this.$router.resolve({path: `/report/${this.url_report}`});            
                window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
            }else{
                toastr.info(`Seleccione una opcion`, 'Error');
            }
        },  
        async mChargeInit(){
            this.list_clima=[];
            let listRiver=await axios.get(`getListLake?api_token=${Vue.auth.getToken()}`);
            // console.log(listRiver);
            this.list_river=listRiver.data;
            let auxRivers=listRiver.data;
            let groupTitle=null;
            let auxOptions='';
            auxRivers.forEach( (el,index) => {
                if(index===0){
                    groupTitle=el.cuenca;
                    auxOptions+=`<optgroup label="${el.cuenca}">`;
                    auxOptions+=`<option value="${el.id}">${el.name_lake}</option>`;
                }else if(groupTitle===el.cuenca){
                    auxOptions+=`<option value="${el.id}">${el.name_lake}</option>`;
                }else{
                    auxOptions+=`</optgroup>`;
                    groupTitle=el.cuenca;
                    auxOptions+=`<optgroup label="${el.cuenca}">`;
                    auxOptions+=`<option value="${el.id}">${el.name_lake}</option>`;
                }

            });
            auxOptions+=`</optgroup>`;
            this.option_river=auxOptions;
        },
         mSelectSector(){
            // aqui indicamos la descripcion del sector
            // this.sector_select=
            console.log(this.sector_select);
            this.read_river.sector=this.sector_select.id_sector;
        },
        mSelectRiver(){
            let auxcode=this.lake_select_aux;
            let ind_aux=this.list_river.findIndex((val, index)=> val.id == auxcode);
            // console.log(ind_aux);
            // console.log(this.list_river.findIndex((val, index)=> val.id === auxcode));
            this.lake_select=this.list_river[ind_aux];
            // console.log(this.lake_select);
            this.mSelectRiverListSector();
        },
        async mSelectRiverListSector(){
            this.list_sector=[];
            // console.log(this.sector_register_edit.id_sector.id_sector);
            // this.sector_register_edit.id_sector.id_sector=0;
            // console.log(this.sector_register_edit.id_sector.id_sector);
            let r_sector=await axios.get(`getSectorRegister/${this.lake_select.id}?api_token=${Vue.auth.getToken()}`);
            console.log(r_sector);
            this.list_sector=r_sector.data;
        }
    },
    computed:{

    },
    components:{
        lineChart
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/river/reportRiver.vue